export const state = {
  // loading: false,
  // navMenu: false,
  // flash: {
  //   type: 'success',
  //   message: '',
  //   show: false,
  // },
  // confirm: {
  //   message: '',
  //   buttons: [],
  //   show: false,
  // },
};
